export default __webpack_public_path__ + "static/client-session-ab58c25ed8b56705f15df3bf0c407262.svg";